import { TextFieldProps } from "@mui/material";

export const makeGetErrorAndHelperText = (t: any = (str: string) => str) => (
  field: any,
): { error: boolean; helperText?: string } => {
  const helperText = field.meta.touched && field.meta.error && t(field.meta.error);
  const error = !!helperText;
  if (!error) {
    return { error };
  }
  return { error, helperText };
};

export const getErrorAndHelperTextNoTranslation = makeGetErrorAndHelperText();

export const textFieldProps = (label: string): TextFieldProps => ({
  id: label,
  label,
  fullWidth: true,
  variant: 'outlined',
  margin: 'normal',
});
